import { EBreakpoint } from '../constants/breakpoints';
import { useViewport } from './general/viewport/useViewport';

export const useMedia = (breakpoint: EBreakpoint) => {
  const { width } = useViewport();
  return {
    down: width < breakpoint,
    up: width >= breakpoint,
  };
};

export const IS_MOBILE = window.innerWidth < EBreakpoint.MD;
